import Carousel from './carousel';

/**
 * FrontPageCarousel creata Slick carousel for Hedin front page.
 */
export default class FrontPageCarusel {

  #carousel;

  #dom = {};

  /**
   * @constructor
   * @param {HTMLElement} element container element
   */
  constructor(element) {
    this.#dom.element = element;
    const carouselElements = this.#dom.element.querySelector('.front-page-carousel__main .front-page-carousel__lifts');
    this.#carousel = new Carousel(carouselElements, this.#carouselSettings());
  }

  /**
   * Called after carousel page is changed automaticly or by user. Used to update page number.
   * @param {Event} event after
   * @param {SlickCarousel} slick SlickCarousel instance
   * @param {number} currentSlide current slide index
   */
  #afterChangeCallback(event, slick, currentSlide) {
    this.#dom.element.querySelector('.hedin-pagination__current-page').innerText = currentSlide + 1;
  }

  /**
   * Slick carousel setting are documented here - https://kenwheeler.github.io/slick/
   * @returns {object} Slick carousel settings
   */
  #carouselSettings() {
    return {
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: false,
      arrows: true,
      prevArrow: this.#dom.element.querySelector('.slick-prev'),
      nextArrow: this.#dom.element.querySelector('.slick-next'),
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 300,
      pauseOnHover: false,
      pauseOnFocus: false,
      fade: true,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            dotsClass: 'slick-dots left',
          }
        },
        {
          breakpoint: 1024,
          settings: {
          }
        }
      ],
      afterChangeCallback: this.#afterChangeCallback.bind(this)
    }
  }

  /**
   * Static method to  initializes carousel in master.js
   */
  static init() {
    const carousel = document.querySelector('.front-page-carousel');

    if(carousel) {
      new FrontPageCarusel(carousel);
    }
  }
}
